<template>
  <div class="w3-container">
    <header class="w3-hide-print">
      <h2>Dashboard</h2>
    </header>
    <div class="w3-row w3-hide-print w3-margin-bottom">
      <div class="w3-col s12 m6 l4 dashButtonContainerGrid w3-margin-bottom">
        <div>
          <div class="w3-white outline dashButtonGrid">
            <div class="w3-text-blue dashButtonIcon">
              <template v-if="state.user.isAdmin && !state.fakeClient">
                <i class="fas fa-money-check w3-xxlarge"></i>
              </template>
              <template v-else>
                <i class="fas fa-file-invoice w3-xxlarge"></i>
              </template>
            </div>
            <div>
              <p class="dashButtonText">
                <template v-if="state.user.isAdmin && !state.fakeClient">Expenses</template>
                <template v-else>Invoices</template>
              </p>
              <p class="dashButtonNumber">
                <template v-if="state.user.isAdmin && !state.fakeClient">
                  {{state.admin.global.expenses.month}}
                </template>
                <template v-else>
                  {{state.user.invoices.total}}
                </template>
              </p>
            </div>
            <div class="w3-clear"></div>
          </div>
        </div>
        <div>
          <div class="w3-white outline dashButtonGrid">
            <div class="w3-text-green dashButtonIcon">
              <template v-if="state.user.isAdmin && !state.fakeClient">
                <i class="fas fa-money-bill-wave w3-xxlarge"></i>
              </template>
              <template v-else>
                <i class="fas fa-globe w3-xxlarge"></i>
              </template>
            </div>
            <div>
              <p class="dashButtonText">
                <template v-if="state.user.isAdmin && !state.fakeClient">Income</template>
                <template v-else>Domains</template>
              </p>
              <p class="dashButtonNumber">
                <template v-if="state.user.isAdmin && !state.fakeClient">{{state.admin.global.income.month}}</template>
                <template v-else>{{state.user.domains.total}}</template>
              </p>
            </div>
            <div class="w3-clear"></div>
          </div>
        </div>
        <div>
          <div class="w3-white outline dashButtonGrid">
            <div class="w3-text-orange dashButtonIcon">
              <template v-if="state.user.isAdmin && !state.fakeClient">
                <i class="fas fa-file-invoice w3-xxlarge"></i>
              </template>
              <template v-else>
                <i class="fas fa-folder w3-xxlarge"></i>
              </template>
            </div>
            <div>
              <p class="dashButtonText">
                <template v-if="state.user.isAdmin && !state.fakeClient">Unpaid Invoices</template>
                <template v-else>Subscriptions</template>
              </p>
              <p class="dashButtonNumber">
                <template v-if="state.user.isAdmin && !state.fakeClient">{{state.admin.global.income.month}}</template>
                <template v-else>{{state.user.subs.total}}</template>
              </p>
            </div>
            <div class="w3-clear"></div>
          </div>
        </div>
        <div>
          <div class="w3-white outline dashButtonGrid">
            <div class="w3-text-purple dashButtonIcon">
              <template v-if="state.user.isAdmin && !state.fakeClient">
                <i class="fas fa-envelope w3-xxlarge"></i>
              </template>
              <template v-else>
                <i class="fas fa-envelope w3-xxlarge"></i>
              </template>
            </div>
            <div>
              <p class="dashButtonText">
                <template v-if="state.user.isAdmin && !state.fakeClient">Unread Tickets</template>
                <template v-else>Mailboxes</template>
              </p>
              <p class="dashButtonNumber">
                <template v-if="state.user.isAdmin && !state.fakeClient">{{state.admin.global.tickets.unread}}</template>
                <template v-else>{{state.user.messages.total}}</template>
              </p>
            </div>
            <div class="w3-clear"></div>
          </div>
        </div>
      </div>
      <div class="w3-col s12 m6 l8">
        <div class="outline w3-white" :style="{'margin-left': state.width > 1024 ? '8px':'0'}">
          <sitesList :limit="5"></sitesList>
        </div>
      </div>
    </div>

    <template v-if="!state.user.isAdmin || state.fakeClient">
      <div>
        <invoicesList :limit="3" v-on:viewDetails="viewDetails = $event"></invoicesList>
      </div>

      <div class="w3-hide-print" v-if="!viewDetails">
        <subscriptionList></subscriptionList>
      </div>

      <!-- <div class="w3-hide-print" v-if="!viewDetails">
        <domainsList></domainsList>
      </div> -->
    </template>

    <!-- TODO: add more admin content, maybe leads section or something -->
    <!-- <template v-if="state.user.isAdmin && !state.fakeClient">
    </template> -->
  </div>
</template>

<script>
import invoicesList from '@/components/invoicesList'
import domainsList from '@/components/domainsList'
import subscriptionList from '@/components/subscriptionList'
import sitesList from '@/components/sitesList'
var dataStore = require('../dataStore').default

export default {
  name: 'Dashboard',
  data() {
    return {
      state: dataStore.state,
      viewDetails: false
    }
  },
  components: {
    invoicesList,
    domainsList,
    subscriptionList,
    sitesList
  }
}
</script>

<style scoped>
.domainRow {background:#f5f5f5;}
.domainRow:hover {
  background: #eee;
}
.dashButtonText,.dashButtonNumber {font-family:'Roboto', sans-serif;}
.dashButtonContainerGrid {display:grid; grid-template-columns: 1fr 1fr; grid-gap: 8px;}
.dashButtonGrid {display:grid; grid-template-columns: 1fr 3fr; padding:5px 8px;}
.dashButtonIcon {height: 50px; display: grid; align-items: center; justify-content: center;}
.dashButtonText {margin:5px 0 0 3px; font-size:0.9rem; font-family:'Raleway'}
.dashButtonNumber {margin:0 0 0 3px; font-size:1rem; font-weight:900;}

@media (max-width:992px) {
  .dashButtonText {margin-left:8px;}
  .dashButtonNumber {margin-left:8px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue